import React from 'react';
import { node, func, string, number } from 'prop-types';
import classnames from 'classnames';
import getRenderable from '../../../lib/getRenderable';
import { BASE_CLASSES } from './constants';
import './index.scss';

const getIconStyle = ({ size, color }) => ({
    width: `${size}px`,
    height: `${size}px`,
    fill: color
});

const Icon = ({
    onClick,
    className,
    color,
    children,
    size
}) => {
    const isOnClickValid = typeof onClick === 'function';
    const classes = classnames(BASE_CLASSES, className, {
        'fit-icon-clickable': isOnClickValid
    });
    const iconStyle = getIconStyle({ size, color });
    const ElementTag = isOnClickValid ? 'button' : 'span';
    const props = {
        className: classes,
        style: iconStyle
    };

    if (isOnClickValid) {
        Object.assign(props, { onClick });
    }

    return (
        <ElementTag {...props}>
            {getRenderable(children)}
        </ElementTag>
    );
};

Icon.propTypes = {
    /**
     * An `<svg>` element.
     */
    children: node.isRequired,
    /**
     * A click callback function.
     */
    onClick: func,
    /**
     * The icon's color.
     * Accepts any CSS-supported color.
     */
    color: string,
    /**
     * The icon's size, in pixels.
     */
    size: number,
    /**
     * Custom classes you wish to pass to the component.
     */
    className: string
};

Icon.defaultProps = {
    size: 16
};

export default Icon;
